import {useTranslation} from "react-i18next";
import React from "react";
import {makeRequest} from "../../../services/requestService";
import {API_URL} from "../../../constants";
import {Box, Button, Divider, List, ListItem, Toolbar, Typography} from "@mui/material";
import TagSetCard from "./TagSetCard";
import StandardDialogSlide from "../../general/dialog/StandardDialogSlide";
import CreateTagsCollection from "./CreateTagsCollection";
import PropTypes from "prop-types";
import {SearchInput} from "../../Search/SearchDialog";
import InfiniteScroll from "react-infinite-scroll-component";

export default function PublicTags(props) {
    const {title} = props;
    const {t} = useTranslation('common');
    const SIZE = 12;
    const [labelSet, setLabelSet] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [openCreate, setOpenCreate] = React.useState(false);
    const [totalPages, setTotalPages] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(0);

    React.useEffect(() => {
        if (!loading)
            return;
        let timeoutId;
        makeRequest(`${API_URL}/label/sets/public?page=0&size=${SIZE}&idOnly=true`).then((response) => {
            if (response.status === 200) {
                setLabelSet(response.data.data);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.currentPage);
                timeoutId = window.setTimeout(() => {
                    setLoading(false);
                }, 200);
            }
        });
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [loading]);

    const fetchMore = () => {
        makeRequest(`${API_URL}/label/sets/public?page=${currentPage + 1}&size=${SIZE}&idOnly=true`).then((response) => {
            if (response.status === 200) {
                setLabelSet(prevState => [...prevState, ...response.data.data]);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.currentPage);
            }
        });
    }

    return (
        <>
            <Toolbar sx={{display: "flex", justifyContent: "space-between"}}>
                <Typography variant="h5" color="textSecondary" fontWeight="bold">{title}</Typography>
                <SearchInput bgcolor={theme => theme.palette.background.menu}/>
            </Toolbar>
            <Divider sx={{bgcolor: theme => theme.palette.secondary.dark, height: "3px", m: 1}}/>
            <Box
                sx={{
                    flexGrow: 1,
                    overflow: "hidden",
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    minHeight: "200px"
                }}
            >
                <List
                    id="publicLabelsList"
                    sx={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        borderRadius: '0.3em',
                        overflow: 'auto',
                        bgcolor: theme => theme.palette.mode === "light" ? theme.palette.background.default : undefined
                    }}>
                    <InfiniteScroll
                        next={fetchMore}
                        hasMore={currentPage + 1 < totalPages}
                        dataLength={labelSet.length}
                        scrollableTarget="publicLabelsList"
                        style={{overflow: "hidden"}}
                    >
                        {!loading && Array.isArray(labelSet) && labelSet.map((set) => (
                            <ListItem key={`label-collection-${set.id}`}>
                                <TagSetCard labelSetID={set.id} onDelete={() => setLoading(true)}/>
                            </ListItem>
                        ))}
                    </InfiniteScroll>
                </List>
            </Box>
            <StandardDialogSlide
                // Create labels collection dialog
                open={openCreate}
                onClose={() => setOpenCreate(false)}
                actions={[
                    <Button
                        key="dialog-create-label-coll-action1"
                        onClick={() => setOpenCreate(false)}
                        color="secondary">
                        {t("main.components.button.cancel")}
                    </Button>
                ]}
            >
                <CreateTagsCollection onSubmit={() => {
                    setOpenCreate(false);
                    setLoading(true);
                }}/>
            </StandardDialogSlide>
        </>
    );
}

PublicTags.propTypes =
    {
        title: PropTypes.string
    }